import { DetailedHTMLProps, HTMLAttributes } from 'react';
import { colors } from 'components/styles/variables';
import check from 'public/static/images/check.svg';

interface CheckboxProps
  extends DetailedHTMLProps<HTMLAttributes<HTMLInputElement>, HTMLInputElement> {
  disabled?: boolean;
}

export default function Checkbox({ ...otherProps }: CheckboxProps): JSX.Element {
  return (
    <div className="container-checkbox">
      <input {...otherProps} type="checkbox" />
      <span className="checkmark">
        <img src={check} alt="check" />
      </span>
      <style jsx>{`
        .container-checkbox {
          position: relative;
          cursor: pointer;
          width: 28px;
          height: 28px;
        }

        input {
          position: absolute;
          width: 28px;
          height: 28px;
          opacity: 0;
          z-index: 2;
          cursor: pointer;
        }

        .checkmark {
          display: flex;
          align-items: center;
          justify-content: center;
          box-sizing: border-box;
          position: absolute;
          width: 28px;
          height: 28px;
          border-radius: 4px;
          border: 2px solid ${colors.G2};
          background-color: ${colors.WHITE};
        }

        input:checked + .checkmark {
          border: none;
          border-radius: 4px;
          background-color: ${colors.ALR1};
        }

        :disabled {
          pointer-events: none;
        }

        :disabled + .checkmark {
          opacity: 0.4;
        }
      `}</style>
    </div>
  );
}
